var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper-full-page auth-page"},[_c('notifications'),_c('div',{class:_vm.pageClass},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }